import { produce } from 'immer';

import {
  GET_NOTIFICATION,
  CLEAR_NOTIFICATION,
  INCREMENT_LOADING,
  DECREMENT_LOADING,
} from './render-controller.actions';

export const initialState = {
  notification: {
    type: '',
    msg1: '',
    status: 0,
    id: '',
  },
  isLoading: 0,
};

export const renderControllerReducer = (state = initialState, action: any) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_NOTIFICATION:
        draft.notification = action.payload;
        break;
      case CLEAR_NOTIFICATION:
        draft.notification = initialState.notification;
        break;
      case INCREMENT_LOADING:
        draft.isLoading += 1;
        break;
      case DECREMENT_LOADING:
        if (draft.isLoading > 0) {
          draft.isLoading -= 1;
        } else {
          draft.isLoading = 0;
        }
        break;
    }
  });
